import React from "react";
import { Subscription } from "react-apollo";
import gql from "graphql-tag";
import { httpClient } from "settings/apolloClient";
import SUBSCRIBE_TO_ITEM_SHIPMENT_QUANTITY from "../graphql/subscriptions/subscribeToItemShipmentQuantity.js";

// Keeps one inventory item's loaded quantity live by writing each event into the
// httpClient cache, where PLANT_LOCATIONS already holds it. Same cache-backed
// pattern as the sensors and actuators.
//
// Renders nothing: the value is displayed by whoever reads that query. Rendering
// the subscription payload instead kept the value in the render-prop's local
// state, so a subscription that was torn down and recreated — or a websocket
// reconnect — left the bar frozen on whatever it had last seen, with nothing to
// resync it.
//
// `itemShipmentQuantity` takes an argument, so its cache key carries the shipment
// id: `variables` has to be given to writeFragment or the patch lands on a
// different key and never reaches the query.
const ITEM_SHIPMENT_QUANTITY = gql`
  fragment ItemShipmentQuantity on InventoryItem {
    itemShipmentQuantity(concreteShipmentId: $concreteShipmentId)
  }
`;

const writeItemShipmentQuantity = (inventoryItemId, concreteShipmentId, quantity) => {
  if (quantity === undefined || quantity === null) return;

  try {
    httpClient.writeFragment({
      id: `InventoryItem:${inventoryItemId}`,
      fragment: ITEM_SHIPMENT_QUANTITY,
      variables: { concreteShipmentId },
      data: {
        __typename: "InventoryItem",
        itemShipmentQuantity: quantity,
      },
    });
  } catch (error) {
    // no-op: the item is not in the cache yet (PLANT_LOCATIONS still loading)
  }
};

const ItemShipmentQuantitySubscriber = ({
  inventoryItemId,
  concreteShipmentId,
}) => (
  <Subscription
    subscription={SUBSCRIBE_TO_ITEM_SHIPMENT_QUANTITY}
    fetchPolicy="no-cache"
    variables={{
      concreteShipmentId,
      inventoryItemId,
    }}
    onSubscriptionData={({ subscriptionData }) => {
      const quantity = subscriptionData
        && subscriptionData.data
        && subscriptionData.data.subscribeToItemShipmentQuantity;

      writeItemShipmentQuantity(inventoryItemId, concreteShipmentId, quantity);
    }}
  >
    {() => null}
  </Subscription>
);

export default ItemShipmentQuantitySubscriber;
